import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { referralAPI } from '../services/api'
import { safeReferralDestination } from './referralDestination'
import './Page.css'

const VISITOR_KEY = 'alchemy_visitor_id'
const VISITOR_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

// One in-flight record per code. React mounts this page twice in development,
// and both mounts would otherwise count as two arrivals.
const pendingVisits = new Map()

function getOrCreateVisitorId() {
  try {
    const existing = localStorage.getItem(VISITOR_KEY)
    if (existing && VISITOR_ID_PATTERN.test(existing)) {
      return existing
    }
    const id = crypto.randomUUID()
    localStorage.setItem(VISITOR_KEY, id)
    return id
  } catch {
    return crypto.randomUUID()
  }
}

function rememberVisitorId(visitorId) {
  if (!visitorId || !VISITOR_ID_PATTERN.test(visitorId)) return
  try {
    localStorage.setItem(VISITOR_KEY, visitorId)
  } catch {
    // Private browsing can block storage. This visit still counts.
  }
}

function recordVisitOnce(code, visitorId) {
  const existing = pendingVisits.get(code)
  if (existing) return existing
  const promise = referralAPI.recordVisit(code, visitorId).finally(() => {
    if (pendingVisits.get(code) === promise) pendingVisits.delete(code)
  })
  pendingVisits.set(code, promise)
  return promise
}

function ReferralRedirect() {
  const { code } = useParams()
  const navigate = useNavigate()
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false

    async function openLink() {
      try {
        const result = await recordVisitOnce(code, getOrCreateVisitorId())
        if (result?.visitor_id) rememberVisitorId(result.visitor_id)
        if (!cancelled) {
          navigate(safeReferralDestination(result?.destination), { replace: true })
        }
      } catch (err) {
        if (!cancelled) {
          setError(err?.status === 404 ? 'This link is not valid.' : (err.message || 'This link could not be opened.'))
        }
      }
    }

    openLink()
    return () => {
      cancelled = true
    }
  }, [code, navigate])

  return (
    <div className="page-container">
      <div className="empty-state">
        <p>{error || 'Taking you to Alchemy…'}</p>
        {error && (
          <Link to="/" className="btn">Go to Alchemy</Link>
        )}
      </div>
    </div>
  )
}

export default ReferralRedirect
